import { gql } from '@apollo/client';

const productsQuery = (categoryId?: string) =>
  categoryId
    ? gql`
    query filteredProducts {
      filteredProducts(categoryId: "${categoryId}") {
          id
          title
          price
          imgUrl
          categoryId
      }
    }
`
    : gql`
        query productsQuery {
          products {
            id
            title
            price
            imgUrl
            categoryId
          }
        }
      `;

export { productsQuery };
